export enum FiAiAssistanceResponseStatus {
    Failed,
    Success,
}

export interface IFiAIAssistanceResponseModel {
    Choices: IFiAIAssistanceChoice[];
    Status: FiAiAssistanceResponseStatus;
}

export interface IFiAIAssistanceChoice {
    Content: string;
}

export interface IAIRequestHistoryModel {
    Message: string;
    Summary: string;
}

export interface IAIAssistancePrompt {
    Title: string;
    Prompt: string;
}

export interface IAIChecklist2Model {
    ChecklistDescription: string;
    CheckpointGroups: IAICheckpointGroupModel[];
}

export interface IAICheckpointGroupModel {
    Name: string;
    Description: string;
    Checkpoints: IAICheckpoint2Model[];
}

export interface IAICheckpoint2Model {
    Name: string;
    Description: string;
}
